export const MILLISECONDS_IN_A_DAY = 86_400_000;
